import styled from "styled-components";
import { useState, useContext, useEffect } from "react";
import { CurrentUserContext } from "../../../Contexts/CurrentUserContext";
import { NotificationContext } from "../../../Contexts/NotificationsContext";
import { DialogWindowContext } from "../../../Contexts/DialogueWindowContext";
import { SpinnerContext } from "../../../Contexts/SpinnerContext";
import AdminNotifications from "./AdminNotifications";
import { InputSwitch } from "primereact/inputswitch";
import {
  saveMessagingDeviceToken,
  checkNotificationPermissions,
  removeTokenFromExistingNotificationProfile,
  getFCMToken,
  messaging,
  VAPID_KEY,
} from "../../../Firebase";

import { getToken, onMessage } from "firebase/messaging";

const PageWrapper = styled.div`
  padding: 10px;

  h3 {
    margin: 0px 0 10px 0;
  }
  p {
    font-size: 14px;
    max-width: 80%;
  }
`;
const LineWrapper = styled.div`
  display: flex;
  gap: 5px;
  justify-content: space-between;
  align-items: start;
  padding-bottom: 10px;

  button {
    padding: 10px 15px;
    border-radius: 5px;
    border: none;
    background-color: var(--primary-color);
    color: white;
    font-weight: 600;
    font-size: 16px;
  }

  @media (min-width: 800px) {
    button {
      font-size: 14px;
      font-weight: 400;
    }
  }
`;

export default function NotificationSettings(props: Props) {
  const currentUser = useContext(CurrentUserContext);
  const userData = currentUser?.currentUser;
  const spinner = useContext(SpinnerContext);
  const dialogWindow = useContext(DialogWindowContext);
  const notificationProfile = useContext(NotificationContext);
  const [supported, setSupported] = useState<boolean>(false);
  const [notificationDenied, setNotificationDenied] = useState<boolean>(false);
  const [FCMToken, setFCMToken] = useState<string>("");
  const [allowNotifications, setAllowNotifications] = useState<boolean>(false);
  const [pastoralCareNotifications, setPastoralCareNotifications] =
    useState<boolean>(false);

  useEffect(() => {
    console.log(Notification.permission);
    if (typeof Notification === "undefined") {
      setSupported(false);
      return;
    }
    setSupported(true);
    if (Notification.permission === "denied") {
      setNotificationDenied(true);
    }

    if (Notification.permission === "granted") {
      setAllowNotifications(true);
      checkNotificationPermissions().then((token) => {
        token && setFCMToken(token);
      });
    }
  }, []);

  async function allowAllNotifications() {
    if (allowNotifications === false) {
      await Notification.requestPermission().then(async (permission) => {
        if (permission === "granted") {
          console.log("Notification permission granted.");
          spinner.setIsLoading(true);
          const msg = await messaging();
          if (!msg) {
            console.error("Messaging is not supported in this browser.");
            spinner.setIsLoading(false);
            return;
          }
          onMessage(msg, (message) => {
            console.log("Received foreground notification. ", message);
            if (message.data && message.data.title && message.data.body) {
              new Notification(message.data.title, {
                body: message.data.body,
                icon: message.data.image,
                tag: message.data.title,
              });
            }
          });
          getToken(msg, { vapidKey: VAPID_KEY }).then((token) => {
            console.log("FCM Token: ", token);
            if (userData && token) {
              saveMessagingDeviceToken(userData, token);
            }
            setAllowNotifications(true);
            dialogWindow.setDialogProps({
              ...dialogWindow,
              showEditWindow: false,
            });
          });
          spinner.setIsLoading(false);
        } else {
          console.log("Unable to get permission to notify.");
          setAllowNotifications(false);
        }
      });
    } else {
      removeTokenFromExistingNotificationProfile(FCMToken);
      setAllowNotifications(false);
    }
  }

  return (
    <PageWrapper>
      {supported ? (
        <>
          {!notificationDenied ? (
            <>
              <LineWrapper>
                <h3>Allow notifications on this device</h3>
                <button onClick={allowAllNotifications}>
                  {allowNotifications ? "Disable" : "Enable"}
                </button>
              </LineWrapper>
              <p>
                A Notification will remind you to do the previous week's report
                if you havn't done it.
              </p>
            </>
          ) : (
            <>
              <p>
                Notifications have been deactivated for this applications.{" "}
                <br />
                To activate notifications check your notifications settings
              </p>
            </>
          )}
        </>
      ) : (
        <>
          <p>
            Your current settings don't allow notifications. <br />
            <br />
            If you are on iPhone you need to add the App to your HomeScreen to
            enable notifications
          </p>
        </>
      )}

      {currentUser &&
        currentUser.currentFirebaseUser?.uid ===
          "3WJ1udT18chFjNcO5OzMhabEAKS2" && (
          <>
            <AdminNotifications FCMToken={FCMToken} />
          </>
        )}
    </PageWrapper>
  );
}

interface Props {}
